export const areLocalHost = () => {
  return import.meta.env.DEV
  // const subdomain = window.location.host.split('.')[0]

  // if (subdomain.indexOf('localhost') !== -1) {
  //   return true
  // } else {
  //   return false
  // }
}

export default {
  areLocalHost,
  DEFAULT_LANGUAGE: 'pt-BR',
  HELP_URL: 'https://docs.regularizei.app.br/',
  HTTP_TIMEOUT: 60000,
  DEFAULT_VECTOR_COLOR: '#FF5722',
  FIRST_SCREEN_AFTER_LOGIN: 'projects',
  DATE_FORMAT: 'd/m/Y',
  FIRST_YEAR: 2016,
  TIMEOUT_UPLOAD_RETRY_SECONDS: 5,
  ONE_MINUTE_IN_MILISECONDS: 60000,
  VIA_CEP_URL: 'https://viacep.com.br/ws',
  OPEN_STREET_MAP_URL: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  MAPBOX_URL: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v10/tiles/256/{z}/{x}/{y}',
  MAPBOX_BACKGROUND_BASE_URL: 'https://api.mapbox.com/styles/v1/adminregularizei/cltt8x35h00kn01qe0r1rd5lh/static',
  MAPBOX_STREETS_URL: 'mapbox://styles/adminregularizei/clnkd9hh0000601qm18gbe7if',
  MAPBOX_PUBLIC_TOKEN: 'pk.eyJ1IjoiYWRtaW5yZWd1bGFyaXplaSIsImEiOiJjbWYyOWNwem4wZzY3MmlvaGx6dnVwdm5yIn0.Hl6gklVK3Izb_82YXItVuA',
  MAPBOX_TOKEN: 'pk.eyJ1IjoiYWRtaW5yZWd1bGFyaXplaSIsImEiOiJjbWYyOWNwem4wZzY3MmlvaGx6dnVwdm5yIn0.Hl6gklVK3Izb_82YXItVuA',
  MAPBOX_UPLOAD_TOKEN: 'sk.eyJ1IjoiYWRtaW5yZWd1bGFyaXplaSIsImEiOiJjbGptdWRiMHcxMjFsM2ZsNWd3ZTdqd3ZrIn0.anb3xQFHSmwhB06jdmitVw',
  MAPBOX_GEOCODING_API: 'https://api.mapbox.com/search/geocode/v6/forward',
  MAP_ATTRIBUTION: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
  TILES_URL: 'https://{s}.tiles.mapbox.com/v4/',
  TILES_END_URL: '/{z}/{x}/{y}.webp',
  MAPBOX_MAX_NATIVE_ZOOM: 21,
  MAPBOX_MAX_SREETS_ZOOM: 22,
  DEFAULT_MIN_ZOOM: 1,
  DEFAULT_MAX_NATIVE_ZOOM: 22,
  DEFAULT_MAX_ZOOM: 24,
  DEFAULT_TIMELINE_PROPERTIES: {
    currentDateAtNewTasks: true,
    currentUserAtNewTasks: true,
    autoFilterWeek: false,
    allowMultipleAssignedUsers: false,
    manageCost: true,
    manageRevenue: false,
    defaultCurrency: 'BRL'
  },
  ZOOM_LEVEL_GSD: {
    1: 78118.912,
    2: 39059.456,
    3: 19529.728,
    4: 9764.864,
    5: 4882.432,
    6: 2441.216,
    7: 1220.608,
    8: 610.304,
    9: 305.152,
    10: 152.576,
    11: 76.288,
    12: 38.144,
    13: 19.072,
    14: 9.536,
    15: 4.768,
    16: 2.384,
    17: 1.192,
    18: 0.596,
    19: 0.298,
    20: 0.149,
    21: 0.075,
    22: 0.037,
    23: 0.019,
    24: 0.0095
  },
  DEFAULT_BOUNDS: [-75, 4, -35, -35],
  DEFAULT_CENTER: [-25.438966, -49.298851],
  DEFAULT_BASEMAP_OPACITY: 0.5,
  WGS84_WKT: '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees',
  PHOTO_MIN_ZOOM: 2,
  PHOTO_MAX_ZOOM: 12,
  PHOTO_MAX_NATIVE_ZOOM: 5,
  ANNOTATION_DEFAULT_WEIGHT: 2,
  ANNOTATION_SELECTED_WEIGHT: 5,
  CACHE_NAME: 'Regularizei',
  USER_ROLES: ['admin', 'user'],
  EMPTY_LAYER_ID: -999,
  ORDER_STEP: 65535,
  CLEAR_TIME: { hour: 0, minute: 0, second: 0, millisecond: 0 },
  API: {
    URL: () => {
      if (areLocalHost()) {
        const currentHost = window.location.hostname
        return currentHost.startsWith('192.') ? `http://${currentHost}:5443` : 'http://localhost:5443'
      } else {
        return 'https://api.regularizei.app.br'
      }
    },
    GRAPHQL: () => {
      if (areLocalHost()) {
        const currentHost = window.location.hostname
        return currentHost.startsWith('192.') ? `http://${currentHost}:5443/graphql` : 'http://localhost:5443/graphql'
      } else {
        return 'https://api.regularizei.app.br/graphql'
      }
    },
    DOWNLOAD_URL: () => {
      return 'https://ishikawa.api.regularizei.app.br/v1'
    },
    ENDPOINTS: {
      DOCUMENTS: {
        DEMO_CONTEXT: '/docs/demo-context',
        CONTEXT: '/docs/context',
        PARSE_TEMPLATE: '/docs/parse-template',
        PARSE_VARIABLE: '/docs/parse-variable',
        GENERATE_PDF: '/docs/generate-pdf',
        PREVIEW_PDF: '/docs/preview-pdf'
      },
      SET_PROJECT_PARTNERS: '/asaas/set-project-partners',
      ASAAS_REFRESH_ACCOUNT: '/asaas/refresh-account',
      INSTALLMENTS_SUMMARY: '/asaas/compute-installments-summary',
      PROCESS_PAYMENT_BOOK: '/asaas/process-payment-book',
      INSTALLMENTS: '/asaas/compute-installments',
      SETUP_2FA: '/2fa/setup',
      VERIFY_2FA: '/2fa/verify',
      STORE_SECRET: '/2fa/store-secret',
      REQUEST_SIGNATURE: '/sign-docs/request',
      UPDATE_SIGNATURE: '/sign-docs/update-signatures',
      UPDATE_CONTRACT_STATUS: '/sign-docs/update-contract-status',
      UPDATE_PARTNER_INTEGRATIONS: '/sign-docs/update-partner-integrations',
      SIGNED_DOCUMENTS_URL: '/sign-docs/download',
      SIGNED_POST: '/aws/signed-post/',
      SIGNED_GET: '/aws/signed-get/',
      MULTIPLE_SIGNED_GET: '/aws/multiple-signed-get/',
      BI_DASHBOARD_URL: '/bi/dashboard',
      AI_EXTRACT_DATA: '/ai/extract-data',
      AI_VALIDATE_DOCUMENT: '/ai/validate-document',
      GEOCODE_ADDRESS: 'https://api.mapbox.com/geocoding/v5/mapbox.places/{address}.json',
      REPORTS: {
        CASH_FLOW: '/reports/cash-flow',
        PENDING_INSTALLMENTS: '/reports/pending-installments',
        ACQUISITION: '/reports/acquisition',
        COMMISSION: '/reports/commission',
        PAYABLES_RECEIVABLES_PIVOT: '/reports/payables-receivables-pivot',
        SUBSCRIPTION_FEES: '/reports/subscription-fees',
        INSTALLMENT_SPLITS: '/reports/installment-splits'
      },
      NOTIFICATION: {
        GET_BY_ID: '/notification/by-id'
      },
      FINANCE: {
        TAX_PROVISION: '/finance/tax-provision',
        MANUAL_PAYMENT: '/finance/manual-payment'
      },
      GEOMETRY: {
        UNION_LANDS: '/geometry/union-lands'
      },
      WHATSAPP: {
        PHONES: '/whatsapp/phones'
      },
      ORGANIZATION: {
        API_TOKEN: '/organization/api-token',
        CHATWOOT_SETUP: '/organization/chatwoot/setup-custom-attributes'
      },
      ADMIN: {
        ORGANIZATION_SETUP: '/admin/organization'
      },
      BILLING: {
        ADMIN_SAVE_ACCOUNT: '/billing/admin/save-account',
        ADMIN_CHARGES: '/billing/admin/charges',
        ADMIN_GENERATE_INVOICE: '/billing/admin/generate-invoice',
        ADMIN_ACCOUNT: '/billing/admin/account',
        ADMIN_CHARGE_TYPES: '/billing/admin/charge-types',
        ADMIN_CHARGE_CONFIGS: '/billing/admin/charge-configs',
        ADMIN_INVOICES: '/billing/admin/invoices'
      }
    }
  },
  AWS: {
    DEFAULT_BUCKET: 'regularizei',
    S3_PUBLIC_URL: 'https://regularizei.s3.amazonaws.com',
    S3_PUBLIC_HOST: 'regularizei.s3.amazonaws.com',
    S3_PRIVATE_URL: 'https://regularizei-docs.s3.amazonaws.com',
    S3_PRIVATE_HOST: 'regularizei-docs.s3.amazonaws.com',
    SINGATURE_URL: () => {
      if (areLocalHost()) {
        return 'https://api.regularizei.app.br' // 'http://localhost:5443'
      } else {
        return 'https://api.regularizei.app.br'
      }
    },
    S3_REGION: 'us-east-1',
    ACCESS_KEY: 'AKIAXMSEWKSLPKYKPVN6'
  },
  BI: {
    URL: 'https://bi.regularizei.app.br/'
  },
  WHITELABEL_DEFAULTS: {
    ORGANIZATION_ID: 2,
    DOMAIN: 'app.regularizei.app.br',
    EMAIL_FROM: 'contato@regularizei.app.br',
    TITLE: 'Regularizei',
    PRIMARY_COLOR: '#0077D3',
    SECONDARY_COLOR: '#424242',
    ACCENT_COLOR: '#000000',
    DARK_ICONS: false,
    MAIN_LOGO: {
      fullPath: 'https://regularizei.s3.amazonaws.com/organizations/1/logo.png',
      path: 'organizations/1/Icon.png',
      size: 6742
    },
    NAV_LOGO: {
      fullPath: 'https://regularizei.s3.amazonaws.com/organizations/1/icon.png',
      path: 'organizations/1/SmallIcon.png',
      size: 3958
    },
    WEBAPP_LOGO: {
      fullPath: 'https://regularizei.s3.us-east-1.amazonaws.com/organizations/1/regularizei_192_192.png',
      path: 'organizations/1/SmallIcon.png',
      size: 3958
    },
    WEBAPP_LOGO_512: {
      path: 'organizations/1/01CFG84WNPTVE38AG4X04ZDGZQ.png',
      size: 3566,
      fullPath: 'https://regularizei.s3.us-east-1.amazonaws.com/organizations/1/regularizei_512_512.png'
    },
    FAV_LOGO: {
      fullPath: 'https://regularizei.s3.amazonaws.com/organizations/1/icon.png',
      path: 'organizations/1/SmallIcon.png',
      size: 3958
    },
    LOGIN_BACKGROUND_IMAGE: {
      fullPath: 'https://regularizei.s3.amazonaws.com/organizations/1/background.jpg',
      path: 'organizations/1/background-01.jpeg',
      size: 1214666
    }
  }
}
